// INTERFACES ########################################################


// ENUMS #############################################################
export enum CalendarModeEnum {
	DAY = 'day',
	DAYTIME = 'daytime',
	MONTH = 'month',
	TIME = 'time'
}
